const colorStrategies = ['Disabled', 'Contrast', 'Fill'];
export default colorStrategies;